import React from "react";

import { Button } from "antd";

import "./DataFieldsDeleteModal.css";

export default function DataFieldsDeleteModal(props) {
  const {
    field, toggleShowDeleteModal, onDelete, refVal,
  } = props;
  return (
    <div ref={refVal} className="deleteModal">
      <div className="dataFieldDeleteModal_spanContainer">
        <span className="dataFieldDeleteModal_text">
          Are you sure you want to delete
          {" "}
          <span className="dataFieldDeleteModal_fieldName">{field}</span>
          {" "}
          ?
        </span>
      </div>
      <div className="dataFieldDeleteModal_buttonContainer">
        <Button type="default" onClick={() => toggleShowDeleteModal()}>Cancel</Button>
        <Button type="primary" onClick={() => onDelete(field)}>Delete</Button>
      </div>

    </div>
  );
}
